import { Meteor } from 'meteor/meteor'
import { dispatch } from '../store'
import { SET_SUGGESTIONS } from '../reducers/suggestions'

export const fetchSuggestions = async () => {
  const suggestions = await Meteor.promise('getSuggestions')

  dispatch({
    type: SET_SUGGESTIONS,
    payload: suggestions,
  })
}
